/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentoBozzaSpuntaForm } from './documento-bozza-spunta-form';


export interface DocumentoBozzaForm { 
    titolo_it: string;
    testo_it: string;
    spunte: Array<DocumentoBozzaSpuntaForm>;
    version?: number;
}

